import * as yup from 'yup';
import * as cardValidator from 'card-validator';

const CardFormSchema = yup.object().shape({
  month: yup.string()
    .test('invalid', 'Enter a valid expiration month', (value, context) => {
      return cardValidator.expirationMonth(value).isValid;
    }),
  year: yup.string()
    .test('invalid', 'Enter a valid expiration year', (value, context) => {
      return cardValidator.expirationYear(value).isValid;
    }),
  verification: yup.string()
    .required('Enter CVV security code')
    .test('invalid', 'Enter a valid CVV security code', (value, context) => {
      const { number } = context.parent;
      const cardBrand = cardValidator.number(number).card?.type;
      const maxLength = (cardBrand === 'american-express') ? 4 : 3;
      return cardValidator.cvv(value, maxLength).isValid;
    }),
  number: yup.string()
    .required('Enter card number')
    .test('invalid', 'Enter a valid card number', (value) => cardValidator.number(value).isValid)
});

export default CardFormSchema;
